import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Cities = ({
  cityNames,
  citylength,
  isHovering,
  handleMouseOut,
  handleMouseOver,
  x,
}) => {
  const navigate = useNavigate();

  const handleClick = (city) => {
    navigate(`/search/${city}`);
  };

  return (
    <div className="z-20 absolute top-[34px]" style={{ marginLeft: `${x}vw` }}>
      <div
        className={`flex flex-col bg-white border   mt-2  rounded w-[150px] text-center   `}
        onMouseOut={() => handleMouseOut()}
        onMouseOver={() => handleMouseOver(cityNames[0][0][0])}
      >
        {cityNames.map((city) => {
          return (
            <div
              className=" text-black hover:bg-[#000000] hover:bg-opacity-70 hover:text-white hover:rounded py-2 font-medium text-[16px] px-2 "
              onClick={() => handleClick(city)}
            >
              {city}
            </div>
          );
        })}
        {citylength > 3 ? (
          <div className=" hover:bg-[#000000] hover:text-white hover:bg-opacity-70 hover:rounded text-gray-400 py-2 font-medium text-[16px] px-2 ">
            More..
          </div>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};

export default Cities;
